import { ltiParams } from 'up';

export interface LtiParamsState {
  ltiParams: ltiParams;
}

export const initialLtiParamsState: LtiParamsState = {
  ltiParams: {
    sectionId: 0,
    isbn: '',
    role: '',
    sectionXid: '',
    lmsName: '',
    userXid: '',
    organizationXid: '',
    resourceLinkId: '',
    goldyAction: '',
    ltiaAction: '',
    isSectionPaired: false,
    platform: '',
    ebookId: '',
    attemptId: 0,
    attemptNo: 0,
    assignmentId: 0,
    epubcfi: '',
    assignmentTitle: '',
    isCourseCopy: false,
    mode: '',
    lmsLocale: '',
    isLockedCourse: false,
    isTemplateCourse: false,
    remainingAttempts: 0,
    latestAttemptNo: 0,
    latestAttemptStatus: '',
    maxAttempts: 0,
    hasAssignmentCompleted: false,
    isCourseNavigationLaunch: false,
    isNeoLaunch: false,
    productDisciplineName: '',
    productXid: '',
    productTitle: '',
    productAuthor: '',
    userId: 0,
  },
};
